// extracted by mini-css-extract-plugin
module.exports = {"policyLinkContainer":"PoliciesTable_policyLinkContainer__2luh5","currencyContainer":"PoliciesTable_currencyContainer__3AUjY"};